var rmUtil = require("../rmlibrary_old/util");
var PDFBlockNode = require("./block");

function PDFAbsoluteNode() {
    PDFBlockNode.apply(this, arguments);
}
rmUtil.inherits(PDFAbsoluteNode, PDFBlockNode);

PDFAbsoluteNode.prototype._getOptions = function() {
    var options = PDFBlockNode.prototype._getOptions.call(this);

    options.top = this.computedStyles.top;
    options.right = this.computedStyles.right;
    options.bottom = this.computedStyles.bottom;
    options.left = this.computedStyles.left;

    return options;
};

PDFAbsoluteNode.prototype.generate = function(pdf) {
    return pdf.absolute(
        this._getOptions(),
        this.children.map(function(child) {
            return child.generate(pdf);
        })
    );
};

module.exports = PDFAbsoluteNode;
